module.exports = __webpack_public_path__ + "static/business-woman-taking-call-8c5f9abda79c1b6c92bf9065639844b2.jpg";